"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icons = _interopRequireDefault(require("../../primitives/Icons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Activity = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-activity padding-1em border br-6px bg-dotted"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-activity-event blue"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    size: "large",
    name: "fire"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-activity-event purple"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: "email"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-activity-event green"
  }, /*#__PURE__*/_react.default.createElement(_Icons.default, {
    size: "large",
    name: "checkcircle"
  })));
};
var _default = exports.default = Activity;